import { Link } from 'react-router-dom';
import { Shield, MessageCircle, Gamepad2 } from 'lucide-react';
import { useSettings } from '../context/SettingsContext';

const Footer = () => {
  const { settings } = useSettings();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t border-white/5 bg-[#030303]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              {settings.logo_url ? (
                <img 
                  src={settings.logo_url} 
                  alt={settings.server_name}
                  className="h-10 w-auto"
                />
              ) : (
                <>
                  <Shield className="w-8 h-8 text-violet-500" />
                  <span className="font-heading font-bold text-xl uppercase tracking-wider gradient-text">
                    {settings.server_name}
                  </span>
                </>
              )}
            </div>
            <p className="text-gray-400 text-sm leading-relaxed max-w-md">
              {settings.description}
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="font-heading font-bold text-white uppercase tracking-wider mb-4">
              Navigation
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-400 hover:text-violet-400 transition-colors text-sm">
                  Accueil
                </Link>
              </li>
              <li>
                <Link to="/rules" className="text-gray-400 hover:text-violet-400 transition-colors text-sm">
                  Règlement
                </Link>
              </li>
              <li>
                <Link to="/join" className="text-gray-400 hover:text-violet-400 transition-colors text-sm">
                  Rejoindre
                </Link>
              </li>
              <li>
                <Link to="/staff" className="text-gray-400 hover:text-violet-400 transition-colors text-sm">
                  Staff
                </Link>
              </li>
              <li>
                <Link to="/status" className="text-gray-400 hover:text-violet-400 transition-colors text-sm">
                  Status
                </Link>
              </li>
            </ul>
          </div>

          {/* Connect */}
          <div>
            <h4 className="font-heading font-bold text-white uppercase tracking-wider mb-4">
              Nous rejoindre
            </h4>
            <div className="space-y-3">
              <a
                href={settings.discord_link}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-gray-400 hover:text-violet-400 transition-colors text-sm"
              >
                <MessageCircle className="w-4 h-4" />
                Discord
              </a>
              <a
                href={`https://${settings.server_ip}`}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-gray-400 hover:text-violet-400 transition-colors text-sm"
              >
                <Gamepad2 className="w-4 h-4" />
                FiveM
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/5 mt-10 pt-6 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-gray-500 text-sm">
            &copy; {currentYear} {settings.server_name}. Tous droits réservés.
          </p>
          <Link 
            to="/admin/login" 
            className="text-gray-600 hover:text-gray-400 text-xs transition-colors"
            data-testid="footer-admin-link"
          >
            <Shield className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
